'use strict';

const _ = require('underscore');
const Base = require('components/Base/Base');
const Events = require('constants/Events');
const Constants = require('constants/Constants');
// const gsap = require('gsap').default;
const TextButton = require('components/Common/TextButton/TextButton');

require('./IndexHero.less');

const Selectors = {
    el: '.IndexHero',
    canvidWrapper: '.IndexHero-sequence',
    image: '.IndexHero-sequenceImage',
    title: '.IndexHero-title',
    subtitle: '.IndexHero-subtitle',
    textButton: '.IndexHero-textButton',
    logos: '.IndexHero-logos',
    whiteBackground: '.IndexHero-whiteBackground',
    whiteBackgroundFeatures: '.IndexFeatures',
    sequenceWrapper: '.IndexHero-sequenceWrapper',
    sequenceInner: '.IndexHero-sequenceInner'
};

const ClassNames = {
    sequence: 'IndexHero-sequence',
    sequenceFallback: 'IndexHero-sequenceFallback'
};

const BindFunctions = [
    'playSequence',
    'fadeOutSequence',
    'activateSectionShown',
    'initVideo',
    'onScroll',
    'onLoaded'
];

const ChildViews = {
    'TextButton': {
        selector: '.TextButton',
        viewConstructor: TextButton
    }
};

module.exports = Base.extend({

    el: Selectors.el,

    initialize: function (options = {}) {
        Base.prototype.initialize.call(this, options);
        _.bindAll(this, BindFunctions);
        this.options = options;

        setTimeout(() => {
            this.waitEvents = [
                {
                    name: Events.home.hero.sequenceEnded
                },
                {
                    name: Events.home.hero.cardLoaded
                }
            ];

            // this.$images = this.$(Selectors.image);
            this.$sequenceWrapper = this.$(Selectors.sequenceWrapper);
            this.$sequenceInner = this.$(Selectors.sequenceInner);
            // this.sequenceTimeLine = gsap.timeline();
            // this.titleObj = {
            //     $container: this.$(Selectors.title),
            //     className: 'IndexHero-titleLine',
            //     autoWidth: true
            // };
            // this.$(Selectors.title).css('opacity', 0);
            // app.utils.splitMultilineToSeparateSpans(this.titleObj);

            this.viewsRegistration(ChildViews);

            this.initVideo(app.settings.hasAutoPlay);
        }, 10);
    },

    initVideo: function (hasAutoplay) {
        this.$sequenceWrapper = this.$(Selectors.sequenceWrapper);
        this.$sequenceInner = this.$(Selectors.sequenceInner);
        const path = this.$sequenceWrapper.data('video-path');
        const pathVideo = path + 'sequence.mp4';
        const callback = () => {
            app.vent.trigger(Events.home.hero.videoSequenceLoaded);
        };
        const className = ClassNames.sequence;

        const params = {
            $container: this.$sequenceInner,
            path: pathVideo,
            className,
            callback
        };

        // this.$(Selectors.title).css('opacity', 1);
        // this.animateTitleTimeline = app.utils.animateTextByLines(this.titleObj, {
        //     lineDuration: 500,
        //     lineDelay: 30,
        //     shift: 30
        // });

        setTimeout(() => {
            this.$(Selectors.title).removeClass('isHide');
            this.$(Selectors.subtitle).removeClass('isHide');
            this.$(Selectors.textButton).removeClass('isHide');
            this.$(Selectors.whiteBackground).removeClass('isHide');
            $(Selectors.whiteBackgroundFeatures).removeClass('isHide');
        }, 10);

        if (app.settings.isIE || !hasAutoplay) {
            let fallbackName = 'fallback.jpg';

            if (app.settings.isWebp) {
                fallbackName = 'fallback.webp';
            }

            this.$img = $('<img>')
                .addClass(className)
                .attr('src', path + fallbackName)
                // .appendTo(this.$sequenceWrapper);
                .appendTo(this.$sequenceInner);

            app.vent.trigger(Events.home.hero.sequenceEntered); // sequence was appended
            callback();

            return;
        }

        this.video = app.utils.createVideoSequence(params);
        app.vent.trigger(Events.home.hero.sequenceEntered); // TODO: Debug
    },

    activateSectionShown: function ($el) {
        if ((!$el || $el && !$el.is(this.$(Selectors.title))) || this.isStarted) {
            return;
        }

        this.playSequence();
    },

    playSequence: function () {
        this.isStarted = true;

        app.utils.waitForEvents(this.waitEvents, () => {
            this.onLoaded();
        });

        if (!this.video) {
            // this.fadeOutSequence();
            // app.els.$body.removeClass(Constants.cssClasses.isInitialState);
            this.$img.addClass(Constants.cssClasses.isShow);
            app.vent.trigger(Events.home.hero.sequenceStarted);
            app.vent.trigger(Events.home.hero.sequenceEnded);

            return;
        }

        this.video.onended = () => {
            // this.fadeOutSequence();
            // app.els.$body.removeClass(Constants.cssClasses.isInitialState);
            app.vent.trigger(Events.home.hero.sequenceEnded);
        };

        $(this.video).addClass(Constants.cssClasses.isShow);
        app.utils.forcePlay(this.video);

        app.vent.trigger(Events.home.hero.sequenceStarted);
    },

    onLoaded: function () {
        setTimeout(() => {
            app.vent.on(Events.common.scroll, this.onScroll);
            this.fadeOutSequence();
            app.els.$body.removeClass(Constants.cssClasses.isInitialState);
        }, 5);
    },

    onScroll: function () {
        //on scroll immidiately hide sequence
        //cause scroll makes enabled right after sequence fade out process start
        //and any scroll at this time reveals sequence and underlying 3d card, that is undesirable
        this.$sequenceWrapper.css('visibility', 'hidden');
        app.vent.off(Events.common.scroll, this.onScroll);
    },

    fadeOutSequence: function () {
        this.$sequenceWrapper.addClass(Constants.cssClasses.isHide);
    }
});
